export default __webpack_public_path__ + "static/media/SAL5.6106535c.jpeg";